import { Thread, ThreadSearchParams, ThreadTab } from "./types";

function parseListParam(param: string | null): string[] {
  return param?.split(",").filter(Boolean) ?? [];
}

export function getQueryParams(params: URLSearchParams): ThreadSearchParams {
  return {
    assignee: parseListParam(params.get("assignee")),
    state: parseListParam(params.get("state")) as Thread["state"][],
    user: parseListParam(params.get("user")),
    limit: Number(params.get("limit")) || 20,
    offset: Number(params.get("offset")),
    search: params.get("search") || "",
    category: parseListParam(params.get("category")),
    staff_assignee: parseListParam(params.get("staff_assignee")),
    tab: params.get("tab") as ThreadTab | null,
  };
}
